import { Document, Page, pdf, Text } from "@react-pdf/renderer"
import { styles, TableCell } from "components"
import { RowExportTypePdf } from "types"
import { DataType } from "../../types"
import { useState } from "react"

type UseExportPdfType = {
  dataInit: DataType
}

export const useExportPdfCompany = ({ dataInit }: UseExportPdfType) => {
  const [data, setData] = useState(dataInit)

  const dropdownAverage = [
    { value: "1", label: "Average Price" },
    { value: "2", label: "Last Price" }
  ]

  const itemBarcode = [
    { value: "1", label: "Item barcode" },
    { value: "2", label: "sku" }
  ]

  const columns = [
    { header: "COMPANY CODE", key: "cc", width: 15 },
    { header: "COMPANY NAME", key: "cn", width: 25 },
    { header: "SUBDOMAIN", key: "subdomain", width: 15 },
    { header: "EMAIL", key: "email", width: 15 },
    { header: "PHONE", key: "phone", width: 15 },
    { header: "MOBILE", key: "mobile", width: 15 },
    { header: "WEBSITE", key: "website", width: 15 },
    { header: "COUNTRY", key: "country", width: 15 },
    { header: "PROVINCE", key: "province", width: 15 },
    { header: "REGENCY", key: "regency", width: 15 },
    { header: "SUBDISTRICT", key: "subdistrict", width: 15 },
    { header: "VILLAGE", key: "village", width: 15 },
    { header: "ADDRESS", key: "address", width: 15 },
    { header: "FINANCE YEAR", key: "fy", width: 15 },
    { header: "METODE AVERAGE PRICE", key: "map", width: 15 },
    { header: "TYPE BARCODE", key: "tb", width: 15 },
  ]

  const dataMap = [
    {
      cc: data?.company_code,
      cn: data?.company_name,
      subdomain: data?.subdomain,
      email: data?.email,
      phone: data?.phone,
      mobile: data?.mobile_phone,
      website: data?.website,
      country: data?.country_name ?? "",
      province: data?.province_name ?? "",
      regency: data?.regency_name ?? "",
      subdistrict: data?.subdistrict_name ?? "",
      village: data?.village_name ?? "",
      address: data?.address,
      fy: data?.finance_year,
      map: data?.methode_avg_price ? dropdownAverage?.find((item) => item.value === data?.methode_avg_price)?.label ?? "" : "",
      tb: data?.barcode_type ? itemBarcode?.find((item) => item.value === data?.barcode_type)?.label ?? "" : "",
    }
  ]

  return {
    setData,
    handleExportPdf: () => pdf(
      <PdfTemplate
        data={dataMap}
        column={columns}
      />
    )
      .toBlob()
      .then((blob) => {
        const url = URL.createObjectURL(blob)
        const link = document.createElement("a")
        link.href = url
        link.download = `company-setting.pdf`
        link.click()
        URL.revokeObjectURL(url)
      })
      .catch((error) => {
        console.error("Gagal membuat PDF:", error)
      })
  }
}

function PdfTemplate({
  data,
  column,
}: {
  data: RowExportTypePdf[]
  column: { header: string; key: string; width: number }[]
}) {
  return (
    <Document>
      <Page size="A4" style={styles.page} orientation="landscape">
        <Text style={styles.title}>COMPANY SETTING</Text>
        <TableCell data={data} column={column} />
      </Page>
    </Document>
  )
}
